import React from 'react';

const IconWrapper = ({ children, color = 'currentColor', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {children}
  </svg>
);

export const SHSIcon = ({ color = 'currentColor', size = 24 }) => (
  <IconWrapper color={color} size={size}>
    <rect
      x="4"
      y="4"
      width="16"
      height="16"
      rx="1.6"
      stroke={color}
      strokeWidth="1.5"
      fill="none"
    />
    <rect
      x="7"
      y="7"
      width="10"
      height="10"
      rx="1"
      stroke={color}
      strokeWidth="1.5"
      fill="none"
    />
  </IconWrapper>
);

export const RHSIcon = ({ color = 'currentColor', size = 24 }) => (
  <IconWrapper color={color} size={size}>
    <rect
      x="4"
      y="4"
      width="16"
      height="16"
      rx="1.6"
      stroke={color}
      strokeWidth="1.5"
      fill="none"
    />
    <rect
      x="7"
      y="7"
      width="10"
      height="10"
      rx="1"
      stroke={color}
      strokeWidth="1.5"
      fill="none"
    />
  </IconWrapper>
);

export const HEAIcon = ({ color = 'currentColor', size = 24 }) => (
  <IconWrapper color={color} size={size}>
    <g transform="translate(12,12) rotate(90)">
      <path
        d="M-8,-4.8 L-8,4.8 M8,-4.8 L8,4.8 M-8,0 L8,0"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
      />
    </g>
  </IconWrapper>
);

export const IPEIcon = ({ color = 'currentColor', size = 24 }) => (
  <IconWrapper color={color} size={size}>
    <g transform="translate(12,12) rotate(90)">
      <path
        d="M-8,-4 L-8,4 M8,-4 L8,4 M-8,0 L8,0"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
      />
    </g>
  </IconWrapper>
);

export const RectConcreteIcon = ({ color = 'currentColor', size = 24 }) => (
  <IconWrapper color={color} size={size}>
    <rect x="6" y="5" width="12" height="14" rx="1" stroke={color} strokeWidth="1.5" fill="none" />
  </IconWrapper>
);

export const TBeamIcon = ({ color = 'currentColor', size = 24 }) => (
  <IconWrapper color={color} size={size}>
    <path d="M5 8 H19 M8 8 V19 M6 19 H18" stroke={color} strokeWidth="1.5" fill="none" />
  </IconWrapper>
);

export const TimberRectIcon = ({ color = 'currentColor', size = 24 }) => (
  <IconWrapper color={color} size={size}>
    <rect x="7" y="6" width="10" height="12" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M9 6 L9 18 M11 6 L11 18 M13 6 L13 18" stroke={color} strokeWidth="0.8" />
  </IconWrapper>
);

export const GlulamIcon = ({ color = 'currentColor', size = 24 }) => (
  <IconWrapper color={color} size={size}>
    <rect x="5" y="7" width="14" height="10" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M5 10 H19 M5 13 H19" stroke={color} strokeWidth="0.8" />
  </IconWrapper>
);
